import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule,DefaultUrlSerializer, UrlTree, UrlSerializer } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { AuthInterceptor } from '../shared/auth.interceptor';
import { NumberDirective } from '../shared/numbersonly.directive';
import { RegistrationlistComponent } from './registrationlist/registrationlist.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { LocationStrategy,HashLocationStrategy } from '@angular/common';
import { MasterpageComponent } from './masterpage/masterpage.component';
import { HeaderComponent } from './header/header.component';
import { SchoolloginComponent } from './School/schoollogin/schoollogin.component';
import { SchoolfeesincreaseComponent } from './School/schoolfeesincrease/schoolfeesincrease.component';
import { AdminfeesincreaseComponent } from './adminfeesincrease/adminfeesincrease.component';
import { SchoolfeesincreaserequestlistComponent } from './School/schoolfeesincreaserequestlist/schoolfeesincreaserequestlist.component';
import { ViewpendingrequestComponent } from './viewpendingrequest/viewpendingrequest.component';
import { ViewallocaterequestComponent } from './viewallocaterequest/viewallocaterequest.component';
import { ViewallallocatedrequestComponent } from './viewallallocatedrequest/viewallallocatedrequest.component';
import { BookdetailComponent } from './bookdetail/bookdetail.component';
import { ExpensedetailComponent } from './expensedetail/expensedetail.component';
import { EstablishmentdetailComponent } from './establishmentdetail/establishmentdetail.component';
import { ScholarshipdetailComponent } from './scholarshipdetail/scholarshipdetail.component';
import { ScholarshiptypeComponent } from './scholarshiptype/scholarshiptype.component';
import { SchooldocumentuploadComponent } from './schooldocumentupload/schooldocumentupload.component';
import { SchoolprofileComponent } from './schoolprofile/schoolprofile.component';
import { ViewprofileComponent } from './School/viewprofile/viewprofile.component';
import { DocumentuploadmasterComponent } from './documentuploadmaster/documentuploadmaster.component';
import { DesignationmasterComponent } from './designationmaster/designationmaster.component';
import { BookrequestComponent } from './School/bookrequest/bookrequest.component';
import { BookpendingrequestComponent } from './bookpendingrequest/bookpendingrequest.component';
import { ExpenserequestComponent } from './School/expenserequest/expenserequest.component';
import { ExpensependingrequestComponent } from './expensependingrequest/expensependingrequest.component';
import { ScholarshiprequestComponent } from './School/scholarshiprequest/scholarshiprequest.component';
import { ScholarshippendingrequestComponent } from './scholarshippendingrequest/scholarshippendingrequest.component';
import { EstablishmentrequestComponent } from './School/establishmentrequest/establishmentrequest.component';
import { EstablishmentpendingrequestComponent } from './establishmentpendingrequest/establishmentpendingrequest.component';
import { SchooldocumentuploadrequestComponent } from './School/schooldocumentuploadrequest/schooldocumentuploadrequest.component';
import { SchooldocumentuploadpendingrequestComponent } from './schooldocumentuploadpendingrequest/schooldocumentuploadpendingrequest.component';
import { SchoolregistrationrequestComponent } from './schoolregistrationrequest/schoolregistrationrequest.component';
import { SchoolregistrationrequestlistComponent } from './schoolregistrationrequestlist/schoolregistrationrequestlist.component';
import { SchoolfullregistrationrequestComponent } from './School/schoolfullregistrationrequest/schoolfullregistrationrequest.component';
import { SchoolfullregistrationrequestlistComponent } from './schoolfullregistrationrequestlist/schoolfullregistrationrequestlist.component';
import { SchoolfullregistrationrequestadminComponent } from './schoolfullregistrationrequestadmin/schoolfullregistrationrequestadmin.component';
import { UsermasterComponent } from './usermaster/usermaster.component';
import { CoursemasterComponent } from './coursemaster/coursemaster.component';
import { InfrastructuremasterComponent } from './infrastructuremaster/infrastructuremaster.component';
import { EmployeetypemasterComponent } from './employeetypemaster/employeetypemaster.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { CollegemasterComponent } from './collegemaster/collegemaster.component';
import { EmployeerequestComponent } from './School/employeerequest/employeerequest.component';
import { EmployeependingrequestComponent } from './employeependingrequest/employeependingrequest.component';
import { ConstructionrequestComponent } from './school/constructionrequest/constructionrequest.component';
import { ConstructionpendingrequestComponent } from './constructionpendingrequest/constructionpendingrequest.component';
import { ConstructiondetailComponent } from './constructiondetail/constructiondetail.component';
import { RentaldetailrequestComponent } from './School/rentaldetailrequest/rentaldetailrequest.component';
import { RentalpendingrequestComponent } from './rentalpendingrequest/rentalpendingrequest.component';
import { RentaldetailComponent } from './rentaldetail/rentaldetail.component';
import { UserrightsComponent } from './userrights/userrights.component';
import { InfrastructurerequestComponent } from './infrastructurerequest/infrastructurerequest.component';
import { LandownerrequestComponent } from './landownerrequest/landownerrequest.component';
import { ClassroomrequestComponent } from './classroomrequest/classroomrequest.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { InfrastructurependingrequestComponent } from './infrastructurependingrequest/infrastructurependingrequest.component';
import { LandownerpendingrequestComponent } from './landownerpendingrequest/landownerpendingrequest.component';
import { ClassroompendingrequestComponent } from './classroompendingrequest/classroompendingrequest.component';
import { RptcollegedetailComponent } from './rptcollegedetail/rptcollegedetail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SchoolrequestlistComponent } from './schoolrequestlist/schoolrequestlist.component';
import { InfrastructuredetailComponent } from './infrastructuredetail/infrastructuredetail.component';
import { ClassroomdetailComponent } from './classroomdetail/classroomdetail.component';
import { LandownerdetailComponent } from './landownerdetail/landownerdetail.component';
import { EmployeeadditionaldetailComponent } from './employeeadditionaldetail/employeeadditionaldetail.component';
import { SchoolregistrationComponent } from './schoolregistration/schoolregistration.component';
import { StudentregistrationComponent } from './studentregistration/studentregistration.component';
import { StudentregisterreportComponent } from './studentregisterreport/studentregisterreport.component';
import { CollegerequestreportComponent } from './collegerequestreport/collegerequestreport.component';
//import { BotDetectCaptchaModule } from 'angular-captcha'; 

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
      return super.parse(url.toLowerCase()); 
  }
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    NumberDirective,
    RegistrationlistComponent,
    MasterpageComponent,
    HeaderComponent,
    SchoolloginComponent,
    SchoolfeesincreaseComponent,
    AdminfeesincreaseComponent,
    SchoolfeesincreaserequestlistComponent,
    ViewpendingrequestComponent,
    ViewallocaterequestComponent,
    ViewallallocatedrequestComponent,
    BookdetailComponent,
    ExpensedetailComponent,
    EstablishmentdetailComponent,
    ScholarshipdetailComponent,
    ScholarshiptypeComponent,
    SchooldocumentuploadComponent,
    SchoolprofileComponent,
    ViewprofileComponent,
    DocumentuploadmasterComponent,
    DesignationmasterComponent,
    BookrequestComponent,
    BookpendingrequestComponent,
    ExpenserequestComponent,
    ExpensependingrequestComponent,
    ScholarshiprequestComponent,
    ScholarshippendingrequestComponent,
    EstablishmentrequestComponent,
    EstablishmentpendingrequestComponent,
    SchooldocumentuploadrequestComponent,
    SchooldocumentuploadpendingrequestComponent,
    SchoolregistrationrequestComponent,
    SchoolregistrationrequestlistComponent,
    SchoolfullregistrationrequestComponent,
    SchoolfullregistrationrequestlistComponent,
    SchoolfullregistrationrequestadminComponent,
    UsermasterComponent,
    CoursemasterComponent,
    InfrastructuremasterComponent,
    EmployeetypemasterComponent,
    ChangepasswordComponent,
    CollegemasterComponent,
    EmployeerequestComponent,
    EmployeependingrequestComponent,
    ConstructionrequestComponent,
    ConstructionpendingrequestComponent,
    ConstructiondetailComponent,
    RentaldetailrequestComponent,
    RentalpendingrequestComponent,
    RentaldetailComponent,
    UserrightsComponent,
    InfrastructurerequestComponent,
    LandownerrequestComponent,
    ClassroomrequestComponent,
    FrontpageComponent,
    InfrastructurependingrequestComponent,
    LandownerpendingrequestComponent,
    ClassroompendingrequestComponent,
    RptcollegedetailComponent,
    DashboardComponent,
    SchoolrequestlistComponent,
    InfrastructuredetailComponent,
    ClassroomdetailComponent,
    LandownerdetailComponent,
    EmployeeadditionaldetailComponent,
    SchoolregistrationComponent,
    StudentregistrationComponent,
    //StudentRegisterReportComponent,
    StudentregisterreportComponent,
    CollegerequestreportComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    HttpClientModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    //BotDetectCaptchaModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
    ,{ provide: LocationStrategy, useClass: HashLocationStrategy}
  , {
    provide: UrlSerializer,
    useClass: LowerCaseUrlSerializer
  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

